import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Headline } from "~/features/ui/headline";
import { Eyebrow } from "~/features/ui/eyebrow";
import { useGalleryBlock } from "~/features/blocks/inventory/gallery/context";
type Props = {
  headline?: string;
  eyebrow?: string;
  text?: React.ReactNode;
};
export function GalleryInfo(props: Props) {
  const {
    headline,
    eyebrow,
    text
  } = props;
  const {
    mode,
    hasInsetDividers
  } = useGalleryBlock();
  const themeStyle = getThemeStyle({
    mode
  });
  if (!headline && !eyebrow && !text) {
    return null;
  }
  return <_StyledDiv $_css={[{
    "display": "flex",
    "flexDirection": "column",
    "rowGap": "2.4rem",
    "padding": "4rem",
    "@media (min-width: 1024px)": {
      "padding": "8rem"
    }
  }, hasInsetDividers && {
    "borderBottomWidth": "1px",
    "@media (min-width: 1024px)": {
      "borderBottomWidth": "0px"
    }
  }, themeStyle.border]}>
      {(headline || eyebrow) && <_StyledDiv2>
          {eyebrow && <Eyebrow text={eyebrow} mode={mode} />}
          {headline && <_StyledHeadline type="h2" text={headline} />}
        </_StyledDiv2>}
      {text}
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-16wemij-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-16wemij-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "rowGap": "0.8rem"
});
var _StyledHeadline = /*#__PURE__*/_styled3(Headline).withConfig({
  displayName: "gallery-info___StyledHeadline",
  componentId: "sc-kqgkdi-0"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});